<template>
  <div class="row mt-4 mx-1r mx-0 mx-md-7">
    <div
      class="col-2 col-md-1 d-flex flex-column justify-content-center position-relative button-prev"
    >
      <div class="position-absolute z-index-carousel-arrow top-sm-6d5">
        <button class="btn btn-primary rounded-circle w-3 h-3">
          <img src="@/assets/images/icons/arrow-left.svg" alt="" />
        </button>
      </div>
    </div>
    <div class="col-0 col-md-10 swiper related-jobs-swiper">
      <div class="swiper-wrapper">
        <div v-for="job in jobs" class="swiper-slide mh-sm-18 border rounded-2">
          <div class="job-related__primary border-0 rounded-2 bg-white-primary p-3 h-15">
            <a
              class="job-related-primary-header cursor-point text-black text-decoration-none"
              target="_blank"
              rel="noopener noreferrer"
              :href="`/jobs/${job.id}?direct=true`"
            >
              <h5 class="size-16">{{ job.title }}</h5>
              <div class="d-flex size-12">
                <p class="mb-0">{{ job.company_name }}</p>
                <p class="mb-0 ms-2 col-3">
                  <img src="@/assets/images/icons/ic_round-place.svg" alt="" />
                  <span>{{ job.prefecture_name }}</span>
                </p>
              </div>
              <p class="size-12">{{ job.range_income }}</p>
              <p class="truncate truncate-line-3">{{ job.description }}</p>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div
      class="col-0 col-md-1 d-flex flex-column justify-content-center align-items-end position-relative button-next"
    >
      <div class="position-absolute z-index-carousel-arrow bottom-sm-5d5">
        <button class="btn btn-primary rounded-circle w-3 h-3">
          <img src="@/assets/images/icons/arrow-right.svg" alt="" />
        </button>
      </div>
    </div>
  </div>
  <div class="swiper-pagination-bullets-primary"></div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue';
import SwiperCore, { Swiper } from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css/pagination';

SwiperCore.use([Navigation, Pagination]);

export default defineComponent({
  props: {
    jobs: {
      type: Array as () => any,
      required: true,
    },
  },
  setup(props) {
    const { jobs } = props;

    onMounted(() => {
      const swiper = new Swiper('.swiper', {
        centeredSlides: true,
        slidesPerView: 'auto',
        loop: true,
        keyboard: {
          enabled: true,
        },
        navigation: {
          nextEl: '.button-next',
          prevEl: '.button-prev',
        },
        pagination: {
          el: '.swiper-pagination-bullets-primary',
          clickable: true,
          enabled: true,
        },
        breakpoints: {
          390: {
            slidesPerView: 1.25,
            spaceBetween: 10,
          },

          640: {
            slidesPerView: 1.25,
            spaceBetween: 10,
          },

          1024: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
        },
      });
    });

    return { jobs };
  },
});
</script>
<style lang="scss">
@import '@/assets/stylesheets/components/_variables.scss';

.job-related__primary {
  @media screen and (min-width: 768px) {
    &:hover {
      background-color: #ececec;
    }

    &:active {
      background-color: #ecf8fa;
    }
  }

  @media screen and (max-width: 576px) {
    &:hover {
      background-color: #ecf8fa;
    }
  }
}

.swiper-pagination-bullets-primary {
  position: static;
  text-align: center;
  transition: 300ms opacity;
  transform: translate3d(0, 0, 0);
  z-index: $z-overlay;
}
</style>
